module.exports = __webpack_public_path__ + "img/video-player/joy@3x-6865e7d725c9c41f78310747512ddc3b.png";